<template>
  <div>
    <!-- <Form
      class="space-y-6"
      :validation-schema="validationSchema"
      dispatch="user/login"
    >
      <Field
        name="email"
        placeholder="Email"
        label="Email"
        :readonly="isSSOCallbackReceived"
      />
      <Field
        type="password"
        name="password"
        placeholder="Password"
        label="Password"
        :readonly="isSSOCallbackReceived"
      />
      <div class="flex flex-wrap justify-between items-center">
        <Button :disabled="isSSOCallbackReceived">Sign In</Button>
        <a
          href="#"
          @click.prevent="openForgotPasswordModal"
          class="text-sm font-semibold text-blue-500"
          :class="{ 'pointer-events-none': isSSOCallbackReceived }"
        >
          Forgot password?
        </a>
        <div class="flex flex-shrink-0 items-center my-4 w-full">
          <span class="w-full min-w-0 h-px bg-gray-800"></span>
          <span class="px-4">OR</span>
          <span class="w-full min-w-0 h-px bg-gray-800"></span>
        </div>

      </div>
    </Form> -->
    <Button type="button" class="w-full" @click="handleMicrosoftSSOSignIn">
      <template v-if="isMicrosoftSSOCallbackReceived"> Authenticating ... </template>
      <template v-else> Sign In with Microsoft </template>
    </Button>
  </div>
</template>

<script>
import { useModal } from '@/helpers/composables';
import { object, string } from 'yup';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { onMounted } from 'vue';

export default {
  setup() {
    const route = useRoute();
    const store = useStore();

    const { open } = useModal('forgot-password');

    const handleMicrosoftSSOSignIn = async () => {
      const { authUrl } = await store.dispatch(
        'get',
        { action: '/microsoft/url' },
        { root: true }
      );
      window.open(authUrl, '_self');
    };

    const authenticatingMicrosoftSSOCallback = async () => {
      await store.dispatch('user/microsoftSsoAuthentication', {
        formData: {
          code: route.query.code,
        },
      });
    };

    function openForgotPasswordModal() {
      open();
    }

    const validationSchema = object({
      email: string().required().email(),
      password: string().required(),
    });

    const isMicrosoftCallback = route.query.state === 'microsoft';

    onMounted(() => {
      if (route.query.code) {
        if (isMicrosoftCallback) {
          authenticatingMicrosoftSSOCallback();
        }
      }
    });

    return {
      isMicrosoftSSOCallbackReceived: route.query.code && isMicrosoftCallback,
      handleMicrosoftSSOSignIn,
      openForgotPasswordModal,
      validationSchema,
    };
  },
};
</script>
